module.exports = __webpack_public_path__ + "img/recommend_success.1e832b2e.png";